/* eslint-disable */
export const CNF_LOADING = 'CNF_LOADING';
export const CNF_LOAD_LIST = 'CNF_LOAD_LIST';
export const CNF_CHANGE_CURRENT = 'CNF_CHANGE_CURRENT';

export const CNF_CHANGE_ITEM = 'CNF_CHANGE_ITEM';
